import { Link01Icon } from '@langchain/untitled-ui-icons';

import { Badge, Text, TextProps, Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { useCopy } from './useCopy';

function CopyID(props: { item: { item: string; prefix: string } }) {
  const { copied, onCopy } = useCopy({
    copy: props.item.item,
  });
  return (
    props.item.item && (
      <button
        type="button"
        className="group flex cursor-pointer items-start gap-2"
        onClick={onCopy}
      >
        <span>
          {props.item.prefix}:{' '}
          <span className="font-mono">{props.item.item}</span>
        </span>

        <span className="opacity-50 transition-opacity group-hover:opacity-70">
          {copied ? 'Copied!' : 'Click to copy'}
        </span>
      </button>
    )
  );
}

type Props = {
  copyItems: {
    prefix: string;
    item: string;
  }[];
  className?: string;
  textSize?: TextProps['variant'];
};

export function CopyMultiButton(props: Props) {
  return (
    <Tooltip
      title={
        <div className="flex flex-col items-start gap-1">
          {props.copyItems.map((item) => (
            <CopyID key={item.prefix} item={item} />
          ))}
        </div>
      }
      side="top"
    >
      <div>
        <Badge
          rounded="full"
          size="md"
          color="primary"
          className={props.className}
        >
          <div className={cn('flex items-center gap-1')}>
            <Link01Icon className="size-4" />
            <Text variant={props.textSize ?? 'h2'}>ID</Text>
          </div>
        </Badge>
      </div>
    </Tooltip>
  );
}
